module.exports = __webpack_public_path__ + "media/src/application/media/no-image-964e9abb61be73676cc88fec092efb78.png";